import { IonImg } from '@ionic/react';
import './HeaderImage.css';

const HeaderImage = (props: any) => {
    return (
        <div className="header-image">
            <IonImg src={props.headerImage} />
        </div>
    );
};
export default HeaderImage;